<template lang="pug">
  div.view-z.flex-row.align-items-center
    div.container
      div.row.justify-content-center
        div.col-md-6
          b-card.shadow-lg.rounded.theme-glass
            div.p-4
              div.d-flex.flex-row.align-items-baseline
                h1 {{ $t("ui.combine.otp_page") }}
                //- p.flex-fill.text-right {{ $t("message.login") }}
              b-form.form-signin(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
                b-input-group
                  DebounceInput(
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    ref="otp_code"
                    v-model.trim.lazy="$v.otp_code.$model"
                    :placeholder='$t("ui.enter_6_digit_code")'
                    :disabled="loading"
                    :dirty="$v.otp_code.$dirty"
                    :error="$v.otp_code.$error"
                    :maxLength="6"
                    class="otp-input-field"
                  )
                ValidateResult(:value="$v.otp_code" :name="$t('ui.otp')")
                div.row
                  div.col
                    b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
                div.row
                  div.col.text-right.mt-2
                    SubmitButton.btn-login(icon="fa fa-sign-in-alt" :text="$t('ui.submit')" variant="secondary" size="lg" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum, numeric } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      otp_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/monitor/status"
    };
  },
  computed: {
    otp2faValidated() {
      return this.$store.getters.get2faValidated;
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.otp_code && this.$refs.otp_code.$el) {
        this.$refs.otp_code.$el.focus();
      }
    });
  },
  validations: {
    otp_code: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    submit: function() {
      this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let url = null;

        if (this.otp2faValidated == 1) {
          url = "validateOTP2fa";
        }
        this.$store
          .dispatch("user/" + url, { code: this.otp_code })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.status

            if (this.submission.success == true) {
              this.$router.push(this.redirect);
            } else {
              this.loading = false;
              this.$router.push("/monitor/status");
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.status ? this.$t("error." + (response.status)) : this.$t("message.invalid_code");
            // this.submission.status = this.$t("message." + (response.status || "otp.verificationFailed"));
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: #ffffff;
}

p {
  color: rgba(255, 255, 255, 0.5);
}

.card {
  margin-bottom: 0 !important;
  // background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

// .btn-login,
// .btn-login:hover {
//   border: 1px solid rgba(0, 0, 0, 0.75);
//   background: #f29941;
//   background: -moz-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: -webkit-linear-gradient(top, #f29941 0%, #e8455d 100%);
//   background: linear-gradient(to bottom, #f29941 0%, #e8455d 100%);
//   color: #ffffff;
//   box-shadow: 0 0 16px rgba(255, 255, 255, 0.25);
// }

.input-group-text {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

input:focus {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: rgba(0, 255, 255, 0.5);
  padding-right: 1.875rem;
  background-repeat: no-repeat;
  background-position: center right calc(1.875rem / 4);
  background-size: calc(1.875rem / 2) calc(1.875rem / 2);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

input.is-valid {
  border: 1px solid rgba(0, 255, 255, 0.5);
}

input.is-invalid {
  border: 1px solid rgba(255, 0, 0, 0.5);
}

.otp-input-field {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
  font-weight: bold;
  padding: 12px;
  min-width: 200px;
  flex: 1;
}

.otp-input-field::placeholder {
  font-size: 1.5rem;
  letter-spacing: 0.1rem;
  opacity: 0.6;
}

.get-otp-btn {
  white-space: nowrap;
  min-width: 100px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
